import { render, staticRenderFns } from "./storeCategories.vue?vue&type=template&id=2cad5260&scoped=true&"
import script from "./storeCategories.vue?vue&type=script&lang=js&"
export * from "./storeCategories.vue?vue&type=script&lang=js&"
import style0 from "./storeCategories.vue?vue&type=style&index=0&id=2cad5260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad5260",
  null
  
)

export default component.exports